<template>
    <div class="spinner-wrapper">
        <double-bounce></double-bounce>
    </div>
</template>


<script>
import { DoubleBounce } from "vue-loading-spinner";
export default {
  name: "Spinner",
  components: {
    DoubleBounce,
  },
};
</script>

<style lang="scss" scoped>
.spinner-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  z-index: 101;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>
